import React from 'react';
import { Instagram } from 'lucide-react';
import { brandData } from '../data/mock';

export const BrandsSection = () => {
  return (
    <section id="brands" className="py-24 md:py-32 bg-[#fffef9] subtle-pattern">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-sm tracking-[0.3em] uppercase text-[#c9a962] mb-4 block">
            Lezzet Koleksiyonu
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-[#1a1a1a] mb-6">
            Markalarımız
          </h2>
          <div className="w-20 h-px bg-[#c9a962] mx-auto"></div>
        </div>

        {/* Brands Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {brandData.subBrands.map((brand, index) => (
            <div 
              key={brand.id}
              className="brand-card p-8 animate-fade-in-up text-center group"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Logo */}
              <div className="brand-logo-container w-28 h-28 mx-auto mb-8 rounded-full overflow-hidden bg-[#f8f6f3] flex items-center justify-center">
                <img 
                  src={brand.logo}
                  alt={`${brand.name} Logo`}
                  className="w-full h-full object-contain p-2"
                />
              </div>

              {/* Brand Name */}
              <h3 className="text-2xl font-light text-[#1a1a1a] mb-3 tracking-wide">
                {brand.name}
              </h3>

              {/* Divider */}
              <div className="w-12 h-px bg-[#c9a962]/40 mx-auto mb-4"></div>

              {/* Description */}
              <p className="text-sm text-[#8a8a8a] mb-6 font-light leading-relaxed">
                {brand.description}
              </p>

              {/* Instagram */}
              <a 
                href={brand.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="instagram-link inline-flex items-center gap-2 text-sm text-[#4a4a4a] hover:text-[#c9a962] transition-colors"
              >
                <Instagram size={16} strokeWidth={1.5} />
                <span className="tracking-wide">{brand.instagram}</span>
              </a>
            </div>
          ))}
        </div>

        {/* Main Brand */}
        <div className="mt-24 text-center">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a962]/30 to-transparent mb-16"></div>
          
          <div className="inline-flex flex-col items-center">
            <img 
              src={brandData.mainBrand.logo}
              alt="DRM Kitchen"
              className="w-24 h-24 object-contain mb-6"
            />
            <span className="text-sm tracking-[0.3em] uppercase text-[#8a8a8a] mb-2">Ana Marka</span>
            <h3 className="text-3xl font-light text-[#1a1a1a] mb-6">DRM Kitchen</h3>
            <a 
              href={brandData.mainBrand.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3 border border-[#1a1a1a] text-[#1a1a1a] text-sm tracking-widest uppercase hover:bg-[#1a1a1a] hover:text-white transition-all duration-300"
            >
              <Instagram size={16} strokeWidth={1.5} />
              <span>Takip Et</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
